import React from 'react';
import { Container } from '@fiverr-private/layout_components';

const comingSoonImageUrl =
  'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/f491243bce4b7e567324fe55aeb50ca6-1727162942845/ES%20Image.png';

export const ComingSoonImage = () => (
  <Container
    flexShrink="0"
    width={242}
    height={138}
    style={{
      backgroundImage: `url(${comingSoonImageUrl})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
    }}
  />
);
